<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}"
            :initial-data="initialData">

        <div class="row">
            <div class="col-12">
                <validated-text-area label="Paragraph 1*" v-model="model.paragraph_1"
                                    :rules="{required: true, max:155}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <validated-text-area label="Paragraph 2*" v-model="model.paragraph_2"
                                    :rules="{required: true, max:175}" :disabled="loading"/>
            </div>
            <div class="col-12">
                <file-input class="c-file-input" ref="file" @input="clearFile" label="Image*" name="Image"
                            v-model="model.image"
                            :disabled="loading">
                    <template #append>
                        <div class="btn-group">
                            <btn v-if="initialData.image"
                                 @click="viewFile(initialData.image)"
                                 type="button" class="fa fa-eye" size="xs"/>
                        </div>
                    </template>
                </file-input>
            </div>
            <div class="col-12">
                <validated-checkbox label="Enabled" v-model="model.is_enabled"
                                :rules="{required: false}" :disabled="loading"/>
            </div>
            <div class="col-12 text-right">
                <btn class="trn" size="sm" :loading="loading" color="primary" text="Update"
                     loading-text="Updating..." :disabled="loading"/>
            </div>
        </div>
    </b-form>
</template>

<script>
import urls from '@/data/cms-urls';

export default {
    name : 'EditVisionMission',

    props : { initialData : { type : Object } },

    data () {
        return {
            addUrl : urls.cms.visionMission.addEdit
        };
    },

    methods : {
        clearFile (file) {
            this.initialData.image = '';
        },
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            this.$notify('Successfully Edited Vision And Mission..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        }
    }
};
</script>

<style scoped>

</style>
